export default "__VITE_ASSET__DeCH3QAe__"